import { call, put, takeLatest, select } from 'redux-saga/effects';
import _ from 'lodash';
import { orgId, Ajax } from 'utils';
import { encode64, formatFormData } from 'utils/ebUtils';
import * as actionTypes from '../actions/actionTypes';
import * as additionalInformationActions from '../actions/additionalInformationActions';

export function* getCustomFields({ payload: { contactId } }) {
  try {
    const url = `/${orgId}/${contactId}/customFields`;
    const { data: result } = yield call(Ajax.get, url);
    const customFields = _.get(result, 'customFields', []);
    const payload = {
      customFields,
    };
    yield put(additionalInformationActions.getCustomFields.success(payload));
  } catch (error) {
    yield put(additionalInformationActions.getCustomFields.fail(error));
  }
}

export function* watchCustomFields() {
  yield takeLatest(actionTypes.GET_ADDITIONALINFO_LIST.ACTION, getCustomFields);
}

export function* saveCustomFields({
  payload: { contactId, customFields, successCallback, failCallback }
}) {
  try {
    const customFieldsParams = formatFormData({ rs: encode64(JSON.stringify(customFields)) });
    const url = `/${orgId}/${contactId}/customFields`;

    const { data: result } = yield call(Ajax.post, url, customFieldsParams, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    if (result.status === 'yes') {
      _.attempt(successCallback, { message: 'ssp.save.success', success: true });
    } else {
      _.attempt(failCallback, {
        message: result.status || 'ssp.register.saveProfile.fail',
        success: false,
      });
    }
    yield put(additionalInformationActions.saveCustomFields.success(result));
  } catch (error) {
    yield put(additionalInformationActions.saveCustomFields.fail({
      saveMyProfile: 'saveMyProfileError'
    }));
  }
}

export function* watchSaveCustomFields() {
  yield takeLatest(actionTypes.SAVE_ADDITIONALINFO.ACTION, saveCustomFields);
}
